<template>
  <div class="header">
    <img
      style="width: 60px; height: 60px"
      src="../../../assets/img/disk.gif"
      alt=""
    />
   
  </div>
</template>

<script>

export default {
  name: "XLbackground",

  data() {
    return {
      degree: 2.5,
    };
  },
  methods: {
    init() {
      var img = document.querySelector("img");
      img.style.display = "none";
      document.onmousemove = function (ev) {
        const scrollY = window.scrollY;
        img.style.display = "block";
        img.style.position = "absolute";
        var x = ev.clientX;
        var y = ev.clientY + scrollY;
        img.style.left = x - img.scrollWidth / 2 + "px";
        img.style.top = y - img.scrollHeight / 2 + "px";
      };

      window.onmouseout = function () {
        img.style.position = "absolute";
      };
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less" scoped>

</style>
